// src/utils/tokenRetry.js
import { requestForToken } from '../firebase';

export class TokenRetryManager {
  static MAX_RETRIES = 3;
  static RETRY_DELAY = 5000; // 5 seconds

  static async ensureToken(garageId, companyId, retryCount = 0) {
    try {
      // Check if we already have a token
      const existingToken = localStorage.getItem('fcm_token');
      if (existingToken) {
        return existingToken;
      }

      // Try to get new token
      const token = await requestForToken(garageId, companyId);
      
      if (token) {
        localStorage.setItem('fcm_token', token);
        return token;
      } else if (retryCount < this.MAX_RETRIES) {
        // Retry after delay
        await new Promise(resolve => setTimeout(resolve, this.RETRY_DELAY));
        return await this.ensureToken(garageId, companyId, retryCount + 1);
      } else {
        return null;
      }
    } catch (error) {
      console.error('Error ensuring token:', error);
      return null;
    }
  }

  static async retryIfNeeded(garageId, companyId) {
    // Check if token is already valid
    const token = localStorage.getItem('fcm_token');
    if (token) {
      // Verify token is not too old (older than 24 hours)
      const tokenTime = localStorage.getItem('fcm_token_time');
      if (tokenTime && Date.now() - parseInt(tokenTime) < 24 * 60 * 60 * 1000) {
        return token;
      }
    }
    
    // Get new token
    return await this.ensureToken(garageId, companyId);
  }
}